module.exports = __webpack_public_path__ + "img/preloader_card.42bc37ea.gif";